var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.isProcessing)?_c('div',{staticClass:"spinner-container"},[_c('i',{staticClass:"spinner",style:(_vm.spinnerStyle)})]):_vm._e(),(!_vm.isProcessing)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }